import { createContext, useContext, useMemo } from 'react';
import { useAuthContext } from './AuthContext';
import { useProfile } from '../hooks/useProfile';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const { isLoggedIn } = useAuthContext();
  const profileState = useProfile({ enabled: isLoggedIn });
  const value = useMemo(() => profileState, [profileState]);

  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>;
}

export function useProfileContext() {
  const ctx = useContext(ProfileContext);
  if (!ctx) {
    throw new Error('useProfileContext must be used within a ProfileProvider');
  }
  return ctx;
}
